<template>
  <section class="ratio">    
    <div class="ratio--wrapper objectFitFallBack-box">        
      <img
        class="content"
        :src="src"
        :title="title"
        :alt="alt"
      />

      <div class="ratio--overlay">
        <slot/>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'RatioBlockImage',
    props: [
      'src',
      'title',
      'alt'
    ]
  }
</script>

<style lang="scss">
  %flexRatioContainer {
    position: relative;
    height: 0;
  }

  %flexRatioContent {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: 100%;
    width: 100%;
  }

  @mixin flexRatio($rw, $rh, $wrapperClass:"ratio--wrapper", $contentClass:"content") {
    .#{$wrapperClass} {
      @extend %flexRatioContainer;
      padding-bottom: ($rh / $rw) * 100%;

      .#{$contentClass} {
        @extend %flexRatioContent;
      }
    }
  }

  img {
    object-fit: cover;
  }

  .ratio {
    background: var(--grey-light);
    width: 100%;

    @include flexRatio(4, 2.6);

    .ratio--overlay {
      position: absolute;
      bottom: 0px;
      width: 100%;

      img {
        height: 25px;
        display: block;
        float: right;
      }
    }
  }

  .object-fit-fallback-box {
    width: 100%;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
</style>